import { useEffect, useState, useCallback } from 'react'
import { Button, NavDropdown } from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import { SliderHeader } from './SliderHeader'
import { SliderProps } from './types'

export const Slider = ({
  title,
  children,
  buttonType = 'button',
  variant = 'dark',
  size = 'sm',
  onAfterOpen,
  style,
  header,
  className = '',
  sliderWidth = '100vw',
  open = false,
}: SliderProps) => {
  const [isPaneOpen, setIsPaneOpen] = useState(open)

  useEffect(() => {
    setIsPaneOpen(open)
  }, [open])

  const handleOpen = useCallback(() => {
    setIsPaneOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setIsPaneOpen(false)
  }, [])

  return (
    <>
      {buttonType === 'dropdown' ? (
        <NavDropdown.Item style={style} className={className} onClick={handleOpen}>
          {title}
        </NavDropdown.Item>
      ) : (
        <Button variant={variant} style={style} className={className} size={size} onClick={handleOpen}>
          {title}
        </Button>
      )}

      <SlidingPane
        overlayClassName="on-top"
        width={sliderWidth}
        isOpen={isPaneOpen}
        title={<SliderHeader>{header ?? title}</SliderHeader>}
        onAfterOpen={onAfterOpen}
        onRequestClose={handleClose}
      >
        {children}
      </SlidingPane>
    </>
  )
}
